import { render } from "./GlobalSystemLoader.vue?vue&type=template&id=51f1f834"
import script from "./GlobalSystemLoader.vue?vue&type=script&lang=js"
export * from "./GlobalSystemLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__